import i18n from '@/shared/i18n';

/**
 * Extract error code from DomainError format: error.data.code
 */
function extractDomainErrorCode(error: unknown): string | null {
  if (
    typeof error === 'object' &&
    error !== null &&
    'data' in error &&
    typeof (error as { data: unknown }).data === 'object' &&
    (error as { data: Record<string, unknown> }).data !== null &&
    'code' in (error as { data: Record<string, unknown> }).data &&
    typeof (error as { data: { code: unknown } }).data.code === 'string'
  ) {
    return (error as { data: { code: string } }).data.code;
  }
  return null;
}

/**
 * Extract error code from oRPC error format: error.code
 */
function extractORPCErrorCode(error: unknown): string | null {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code: unknown }).code === 'string'
  ) {
    return (error as { code: string }).code;
  }
  return null;
}

function extractErrorMessage(error: unknown): string | null {
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as { message: unknown }).message === 'string'
  ) {
    return (error as { message: string }).message;
  }
  return null;
}

export function getErrorMessage(error: unknown): string {
  // 1. DomainError format (error.data.code)
  const domainCode = extractDomainErrorCode(error);
  if (domainCode && i18n.exists(`error:${domainCode}`)) {
    return i18n.t(`error:${domainCode}`);
  }

  // 2. oRPC error format (error.code)
  const orpcCode = extractORPCErrorCode(error);
  if (orpcCode && i18n.exists(`error:${orpcCode}`)) {
    return i18n.t(`error:${orpcCode}`);
  }

  // 3. Fallback to error.message or default
  return extractErrorMessage(error) || i18n.t('error:defaultError');
}
